<ion-label
  mode="md"
  class="card-header-getm"
  [class.card-header-getm--start]="alignment === 'start'"
>
  <ion-text mode="md" class="card-header-getm__title">
    <ng-container *ngIf="titleKey; else directTitle">
      {{ titleKey | translate }}
    </ng-container>
    <ng-template #directTitle>{{ title }}</ng-template>
  </ion-text>

  <ng-container *ngIf="showInfoIcon">
    <ion-button
      fill="clear"
      shape="round"
      class="button-info"
      (click)="onInfoClick()"
    >
      <app-icon-getm
        name="information-circle"
        variant="outline"
        customSize="16px"
        [color]="infoIconColor"
      ></app-icon-getm>
    </ion-button>
  </ng-container>
</ion-label>
